import Header from "../components/Header/Header";
import { zendeskListTicketsUrl, zendeskNewTicketUrl } from "../config";
import useNavigation from "../hooks/navigation";
import { useLogout } from "../hooks/useAuth";

const HeaderContainer = ({
  className,
  sidebarOpen,
  setSidebarOpen,
}: {
  className?: string;
  sidebarOpen?: boolean;
  setSidebarOpen?: (value: boolean) => void;
}) => {
  const navigation = useNavigation();

  const { mutateAsync: mutateLogout, isPending: isLogoutPending } = useLogout({
    redirect: true,
    withRequest: true,
  });

  const onNewZendeskTicket = () => {
    navigation.openUrlWithZendeskAuth(zendeskNewTicketUrl);
  };

  const onListZendeskTickets = () => {
    navigation.openUrlWithZendeskAuth(zendeskListTicketsUrl);
  };

  return (
    <Header
      className={className}
      isLogoutPending={isLogoutPending}
      logout={mutateLogout}
      newZendeskTicket={onNewZendeskTicket}
      listZendeskTickets={onListZendeskTickets}
      sidebarOpen={sidebarOpen}
      setSidebarOpen={setSidebarOpen}
    />
  );
};

export default HeaderContainer;
